<template>
  <el-select
    v-model="selectedSemesterId"
    clearable
    :placeholder="placeholder"
    class="input-common"
    @change="handleChange"
  >
    <el-option
      v-for="semester in semesters"
      :key="semester.id"
      :label="semester.name"
      :value="semester.id"
    ></el-option>
  </el-select>
</template>

<script>
import axios from 'axios';
import { BACKEND_URL } from '../../../share-source/src/config/config.js';

export default {
  name: 'SemesterSelector',
  props: {
    modelValue: {
      type: [Number, String],
      default: null
    },
    placeholder: {
      type: String,
      default: 'Semester'
    }
  },
  data() {
    return {
      semesters: []
    }
  },
  computed: {
    selectedSemesterId: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  },
  mounted() {
    this.fetchSemesters();
  },
  methods: {
    async fetchSemesters() {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/semester/all/paged`, {
          params: {
            page: 0,
            size: 100
          },
          withCredentials: true
        });
        this.semesters = response.data.content;
      } catch (error) {
        console.error("Error fetching semesters:", error);
      }
    },
    handleChange(value) {
      this.$emit('change', value);
    }
  }
}
</script>

<style scoped>
.input-common {
  margin-bottom: 8px;
}
</style> 